import zappy from "@zappy-ride/library.react.components";
import { FormInputVehicle } from "./FormInputVehicle";

export * from "./FormInputVehicle";

zappy.FactoryInstance.registerComponent(FormInputVehicle);
